import { render, staticRenderFns } from "./commend-complaint.vue?vue&type=template&id=0813a260&scoped=true"
import script from "./commend-complaint.vue?vue&type=script&lang=js"
export * from "./commend-complaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0813a260",
  null
  
)

export default component.exports